// extracted by mini-css-extract-plugin
module.exports = {"root":"news-box-module--root--2XeTL","closeIcon":"news-box-module--closeIcon--iaM66"};